(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halloween-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('halloween-cart-add')) {
    customElements.define('halloween-cart-add', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('form').addEventListener('submit', async (event) => {
          event.preventDefault();
          const form = event.currentTarget;
          const button = form.querySelector('button[type="submit"]');
          const error = form.querySelector('[role="alert"]');
          const drawer = document.querySelector('cart-drawer');
          if (button.disabled) return;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          error.hidden = true;
          const data = { items: [{ id: form.elements.id.value, quantity: 1 }] };
          if (drawer) {
            data.sections = drawer.getSectionsToRender().map(section => section.id).join(',');
            data.sections_url = window.location.pathname;
            drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));
          }
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify(data)
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
            if (drawer && result.sections && result.sections['cart-drawer']) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(result);
              requestAnimationFrame(() => drawer.querySelector('.drawer__close')?.focus());
            } else {
              window.location.assign(window.Shopify.routes.root + 'cart');
            }
          } catch (failure) {
            error.textContent = this.dataset.error;
            error.hidden = false;
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-pair-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mini-pair-picker')) {
  customElements.define('mini-pair-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.products = JSON.parse(this.querySelector('[data-products]').textContent).filter(p => p.variants.some(v => v.available));
      this.slots = [...this.querySelectorAll('[data-slot]')];
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      this.money = new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency});
      this.slots.forEach((slot,index) => {
        const select=slot.querySelector('[data-product]');
        this.products.forEach(p => select.add(new Option(p.title,String(p.id))));
        if(index===0 && this.dataset.first) {
          select.value=this.dataset.first;
          select.disabled=true;
          this.populate(slot,this.dataset.variant);
        }
        select.addEventListener('change',()=>{this.populate(slot);this.update();});
        slot.querySelector('[data-variant]').addEventListener('change',()=>this.update());
      });
      this.button.addEventListener('click',()=>this.add());
      this.formHandler=()=>{
        const input=document.getElementById(this.dataset.form)?.querySelector('[name="id"]');
        if(input) {this.populate(this.slots[0],input.value);this.update();}
      };
      this.form=document.getElementById(this.dataset.form);
      this.form?.addEventListener('change',this.formHandler);
      this.update();
    }
    disconnectedCallback(){this.form?.removeEventListener('change',this.formHandler);this.ready=false;}
    populate(slot,preferred) {
      const p=this.products.find(p=>String(p.id)===slot.querySelector('[data-product]').value);
      const select=slot.querySelector('[data-variant]');
      select.replaceChildren(new Option(this.copy.chooseVariant,''));
      select.disabled=!p;
      if(!p)return;
      p.variants.forEach(v=>{const o=new Option(v.title==='Default Title'?p.title:v.title,String(v.id));o.disabled=!v.available;select.add(o);});
      if(preferred && p.variants.some(v=>String(v.id)===preferred && v.available))select.value=preferred;
      else if(p.variants.length===1 && p.variants[0].available)select.value=String(p.variants[0].id);
    }
    selected() {
      return this.slots.map(slot=>{
        const p=this.products.find(p=>String(p.id)===slot.querySelector('[data-product]').value);
        return p?.variants.find(v=>String(v.id)===slot.querySelector('[data-variant]').value && v.available);
      });
    }
    update() {
      const variants=this.selected();
      this.slots.forEach((slot,index)=>{
        const v=variants[index],img=slot.querySelector('[data-image]');
        img.hidden=!v?.image;
        if(v?.image){img.src=v.image;img.alt=v.alt;}
      });
      const ready=variants.every(Boolean);
      this.button.disabled=!ready||this.busy;
      this.querySelector('[data-totals]').hidden=!ready;
      if(!ready)return;
      const regular=variants.reduce((n,v)=>n+v.price,0);
      const total=variants.reduce((n,v)=>n+v.price-Math.round(v.price*.1),0);
      this.querySelector('[data-regular]').textContent=this.money.format(regular/100);
      this.querySelector('[data-total]').textContent=this.money.format(total/100);
      this.querySelector('[data-shipping]').textContent=total>=6000?this.copy.free:this.copy.shipping;
    }
    async add() {
      if(this.busy)return;
      const variants=this.selected();
      if(!variants.every(Boolean)){this.status.textContent=this.copy.unavailable;return;}
      this.busy=true;this.update();this.button.textContent=this.copy.adding;this.status.textContent='';
      const items=[];
      variants.forEach(v=>{const item=items.find(i=>i.id===v.id);if(item)item.quantity++;else items.push({id:v.id,quantity:1});});
      try {
        const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok || result.status)throw new Error('cart');
        window.location.assign(this.dataset.cartUrl);
      } catch {
        this.status.textContent=this.copy.error;
        this.querySelector('[data-cart-check]').hidden=false;
        this.busy=false;this.button.textContent=this.copy.add;this.update();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zenify-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    const addBusinessDays = (startDate, days) => {
      const result = new Date(startDate);
      let remaining = days;

      while (remaining > 0) {
        result.setUTCDate(result.getUTCDate() + 1);
        const weekday = result.getUTCDay();
        if (weekday !== 0 && weekday !== 6) remaining -= 1;
      }

      return result;
    };

    const initialize = (root) => {
      if (root.dataset.zenifyDeliveryReady === 'true') return;
      root.dataset.zenifyDeliveryReady = 'true';

      const locale = root.dataset.locale || 'en';
      const processingDays = Number(root.dataset.processingDays || 1);
      const minimumDays = processingDays + Number(root.dataset.transitMinDays || 6);
      const maximumDays = processingDays + Number(root.dataset.transitMaxDays || 10);
      const today = new Date();
      const calendarDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 12));
      const earliest = addBusinessDays(calendarDate, minimumDays);
      const latest = addBusinessDays(calendarDate, maximumDays);
      const dateFormatter = new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
      });
      const range = typeof dateFormatter.formatRange === 'function'
        ? dateFormatter.formatRange(earliest, latest)
        : dateFormatter.format(earliest) + '–' + dateFormatter.format(latest);
      const dateOutput = root.querySelector('[data-delivery-range]');

      if (dateOutput) {
        const template = root.dataset.displayMode === 'details'
          ? root.dataset.estimatedDetailTemplate
          : root.dataset.estimatedTemplate;
        dateOutput.textContent = template.replace('__RANGE__', range);
      }

      if (root.dataset.shippingRuleSupported !== 'true') return;

      const variants = JSON.parse(root.dataset.variants || '[]');
      const threshold = Number(root.dataset.freeShippingThreshold || 0);
      const shippingOutput = root.querySelector('[data-shipping-message]');
      const productContext = root.closest('section') || document;
      const variantInput = productContext.querySelector('form[action*="/cart/add"] [name="id"]');

      const renderShipping = (variantId) => {
        const variant = variants.find((item) => String(item.id) === String(variantId));
        if (!variant || !shippingOutput) return;

        const isDetails = root.dataset.displayMode === 'details';
        if (Number(variant.price) >= threshold) {
          shippingOutput.textContent = isDetails
            ? root.dataset.freeDetailTemplate
            : root.dataset.freeTemplate;
        } else {
          shippingOutput.textContent = root.dataset.thresholdTemplate;
        }
      };

      if (variantInput) {
        renderShipping(variantInput.value);
        variantInput.addEventListener('change', (event) => renderShipping(event.target.value));
      }
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-zenify-delivery]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
